module.exports = __webpack_public_path__ + "img/21.31f1d032.png";